export default Object.freeze({
  Basic: 'basic',
  Default: 'default',
  BasicBanner: 'basic-banner',
});
